import { FilterInputProps } from '@customer/filters/types';
import TimeOfDayFilter from './TimeOfDayFilter';
import { useTranslation } from 'react-i18next';
import { setTimeOfDayStart } from '@customer/store/slices/filtersSlice';

export const TimeOfDayStartFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownElement>) => {
  const { t } = useTranslation();

  return (
    <TimeOfDayFilter
      filterName="timeOfDayStart"
      label={label ?? t('TimeOfDayStart')}
      elementRef={elementRef}
      action={setTimeOfDayStart}
    />
  );
};

export default TimeOfDayStartFilter;
